import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import api from '../../api/endpoints';
import { handleErrors, fetch } from '../../api';

function* editAccountPhone({ payload: { values, onSuccess, handledErrors } }) {
  
  try {
    const { data } = yield call(fetch, { api: api.profile.phone_edit, data: values });

    onSuccess();
    yield put(actions.editAccountPhoneDone(data.result));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.editAccountPhoneFailed,
      handledErrors,
      endpoint: api.profile.phone_edit.url
    });
  }
}

export const editAccountPhoneSaga = takeEvery(types.EDIT_ACCOUNT_PHONE_REQUEST, editAccountPhone);